import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import logo from '../assets/logo1.jpeg';
import './Navigation.css';

export function Navigation() {
    const { t, language, toggleLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const isRtl = language === 'ar';

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navItems = [
        { label: t('nav.home'), path: '/' },
        { label: t('nav.projects'), path: '/portfolio' },
        { label: t('nav.services'), path: '/services' },
        { label: t('nav.testimonials'), path: '/testimonials' },
        { label: t('nav.about'), path: '/about' },
    ];

    return (
        <>
        <nav className={`lux-navbar ${scrolled ? 'scrolled' : ''}`} dir={isRtl ? 'rtl' : 'ltr'}>
            <div className="lux-nav-container">
                <Link to="/" className="lux-nav-logo" onClick={() => setIsOpen(false)}>
                    <img src={logo} alt="Ayonk Logo" className="lux-logo-img" />
                </Link>

                <div className="lux-nav-desktop">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`lux-nav-item ${location.pathname === item.path ? 'active' : ''}`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </div>

                <div className="lux-nav-actions">
                    {/* Updated Language Text here */}
                    <button className="lux-lang-btn" onClick={toggleLanguage}>
                        {language === 'ar' ? 'English' : 'العربية'}
                    </button>
                    <Link to="/contact" className="lux-contact-btn">
                        {isRtl ? 'تواصل معنا' : 'Contact Us'}
                    </Link>
                    <button className="lux-mobile-toggle" onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? <X size={32} /> : <Menu size={32} />}
                    </button>
                </div>
            </div>

            {/* Mobile Drawer */}
            <div className={`lux-mobile-drawer ${isOpen ? 'open' : ''}`}>
                <div className="lux-drawer-content">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className="lux-mobile-item"
                            onClick={() => setIsOpen(false)}
                        >
                            {item.label}
                        </Link>
                    ))}
                    <div className="lux-mobile-divider"></div>
                    <Link to="/contact" className="lux-contact-btn mobile" onClick={() => setIsOpen(false)}>
                        {isRtl ? 'تواصل معنا' : 'Contact Us'}
                    </Link>
                </div>
            </div>
        </nav>
        <div className="nav-spacer"></div>
        </>
    );
}
